function radioMulticollection() {
  const headingMulticollection = document.querySelector('.js-radio-multicollection');
  const contentMulticollection = document.querySelector('.js-subcollection');
  if (Boolean(headingMulticollection)) {
    const inputsSubcollectionHeading = document.querySelector(`.js-radio-multicollection input[name="collection-heading"]`);
    inputsSubcollectionHeading.checked = true ;
    headingMulticollection.addEventListener('change', (e) => {
      if (e.target.tagName == 'INPUT') {
        let inputTarget = e.target;
        let contentBlock = contentMulticollection.querySelector(`#subcollection-${inputTarget.value}`);
        if(Boolean(contentBlock)){
          contentMulticollection.querySelectorAll(`.subcollection-item`).forEach(element => element.classList.add('hidden'));
          contentBlock.classList.remove('hidden');
        }
      }
    }); 
  }
  if (Boolean(contentMulticollection)) {
    const inputsSubcollection = document.querySelectorAll(`.js-subcollection .input-subcollection[value="todos"]`);
    inputsSubcollection.forEach((item) => item.checked = true );
    contentMulticollection.addEventListener('change', (e) => {
      if (e.target.tagName == 'INPUT') {
        let inputTarget = e.target;
        let contentGrid = contentMulticollection.querySelector(`.subcollection-grid-${inputTarget.dataset.block}`);
        contentGrid.setAttribute("data-subcollection", inputTarget.value);
      }
    }); 
  }
}
function listenButtonClick() {
  const buttonGoUp = document.querySelector('.goupbtn');
  if (buttonGoUp) {
    buttonGoUp.addEventListener('click', (e)=>{
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Desplazamiento suave
      });
    });
  }
}
function listenButtonVisibility() {
  const buttonGoUp = document.querySelector('.goupbtn');
  if (buttonGoUp) {
    if (window.scrollY > 300) {
      buttonGoUp.classList.add("show");
    } else {
      buttonGoUp.classList.remove("show");
    } 
  }
}
function listenAnnouncementVisibility() {
  const announcementSection = document.querySelector('.announcement-bar-section');
  const headerSection = document.querySelector('.section-header');
  if (announcementSection) {
    if (window.scrollY > 0) {
      announcementSection.classList.add("A-sticky");
    } else {
      announcementSection.classList.remove("A-sticky");
    } 
  }
}
window.addEventListener("DOMContentLoaded", (e) => {
  radioMulticollection();
  listenButtonVisibility();
  listenButtonClick();
  listenAnnouncementVisibility();
});
window.addEventListener("scroll", (e) => {
  listenButtonVisibility();
  listenAnnouncementVisibility();
});